import React from "react";
import AccountSectionRouter from "./AccountSectionRouter";
import PropTypes from "prop-types";
import AccountSubbarContainer from "./AccountSubbarContainer";
import NoMatch from "./NoMatch";
import MainFrameContainer from "./MainFrameContainer";
import { withRouter } from "react-router-dom";
import CenteredProgress from "./CenteredProgress";
import SortPeopleToggleContainer from "./SortPeopleToggleContainer";

const Account = props => {
  const { tabIndex, loading, account, location } = props;

  const exists = loading || (account && account.name);

  const renderSecondaryControl = () => {
    if (tabIndex === 1) {
      return <SortPeopleToggleContainer />;
    }
    return null;
  };

  const renderBody = () => {
    if (loading) {
      return <CenteredProgress />;
    }
    return <AccountSectionRouter account={account} />;
  };

  if (!exists) {
    return <NoMatch url={location.pathname} />;
  }

  return (
    <MainFrameContainer
      body={renderBody(loading)}
      appBarHeight={100}
      title={loading ? "Loading..." : account && account.name}
      subBar={
        <AccountSubbarContainer secondaryControl={renderSecondaryControl()} />
      }
    />
  );
};

Account.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  account: PropTypes.object,
  loading: PropTypes.bool.isRequired
};

export { Account };

export default withRouter(Account);



// WEBPACK FOOTER //
// ./src/Account.js